// JsFromRoutes CacheKey 9315a8d29447803c36878d67a44e2166
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from 'utils/js_from_routes_client'

export default {
  requestEmployeeStatusReport: /* #__PURE__ */ definePathHelper('post', '/admin/employers/:id/request_employee_status_report'),
  updateMergeCompanyIds: /* #__PURE__ */ definePathHelper('patch', '/admin/employers/:id/update_merge_company_ids'),
  deleteDocument: /* #__PURE__ */ definePathHelper('delete', '/admin/employers/:id/delete_document'),
  deletePartnerRelationship: /* #__PURE__ */ definePathHelper('delete', '/admin/employers/:id/delete_partner_relationship'),
  deletePlaidAccount: /* #__PURE__ */ definePathHelper('delete', '/admin/employers/:id/delete_plaid_account'),
  draftIneligibleSpendReport: /* #__PURE__ */ definePathHelper('get', '/admin/employers/:id/draft_ineligible_spend_report'),
  draftIneligibleSpendTransactionList: /* #__PURE__ */ definePathHelper('get', '/admin/employers/:id/draft_ineligible_spend_transaction_list'),
  index: /* #__PURE__ */ definePathHelper('get', '/admin/employers'),
  show: /* #__PURE__ */ definePathHelper('get', '/admin/employers/:id'),
  update: /* #__PURE__ */ definePathHelper('patch', '/admin/employers/:id'),
}
